import { useQuery } from "react-query";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";
import UIPersonalizationDataService from "../../services/ui-personalization-data-service/UIPersonalizationDataService";
import { IUIUserFavoriteModel } from "../../services/ui-personalization-data-service/Models";

export type UseUserFavoriteParameters = {
} & BaseUseQueryParameters<Array<IUIUserFavoriteModel>>;

export function useUserFavorites({
    enabled,
    onError,
    onSuccess
}: UseUserFavoriteParameters) {
    return useQuery<Array<IUIUserFavoriteModel>, RestError>(
        keys.favoriteList(),
        async ({ signal }) => {
            const favorites = await UIPersonalizationDataService.getUserFavorites(signal);
            return favorites.sort((a, b) => a.order - b.order)
        },
        {
            enabled: enabled,
            onError: onError,
            onSuccess: onSuccess
        }
    );
}